const formStyle = {
        control: (base: any, state: any) => ({
            ...base,
            border: "1px solid #fff !important",
            borderRadius: "0px",
            backgroundColor: state.isDisabled ? "#adadad" : "var(--input-color)",
            boxShadow: "none",
            minHeight: "45px",
        }),
        placeholder: (base: any, state: any) => ({
            ...base,
            color: state.isFocused ? "var(--input-color)" : "var(--text-color)",
            backgroundColor: "transparent",
            fontSize: "14px",
        }),
        menu: (base: any) => ({
            ...base,
            overflowY: "auto",
            scrollbarWidth: "none",
            color: "var(--text-color)"
        }),
        menuList: (base: any) => ({
            ...base,
            maxHeight: "160px",
        }),
        menuPortal: (base: any) => ({
            ...base,
            zIndex: 2,
        }),
        option: (base: any, state: any) => ({
            ...base,
            backgroundColor: state.isFocused ? "#eee" : "",
            color: "var(--text-color)",
            fontWeight: state.isSelected ? "bold" : "",
        }),
        singleValue: (base: any, state: any) => ({
            ...base,
            color: state.selectProps.menuIsOpen ? "var(--input-color)" : state.isSelected ? "var(--text-color)" : "var(--text-color)",
        }),
        multiValueRemove: (base: any) => ({
            ...base,
            color: 'red',
        }),
    };

export default formStyle;